export const pageTransitionVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -10,
  },
};

export function getPageTransitionConfig(skipAnimation = false) {
  if (skipAnimation) {
    return {
      transition: { duration: 0 },
      variants: {
        initial: { opacity: 1, y: 0 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 1, y: 0 },
      },
    };
  }

  return {
    transition: { duration: 0.24, ease: 'easeOut' },
    variants: pageTransitionVariants,
  };
}
